module.exports = __webpack_public_path__ + "img/dol114.87f373f4.jpeg";